import Form from './CookiesTagsForm'
import schema from './schema'

export { Form, schema }

export default Form
